import { render, staticRenderFns } from "./TablaInfoGral.vue?vue&type=template&id=4051da34&scoped=true&"
import script from "./TablaInfoGral.vue?vue&type=script&lang=ts&"
export * from "./TablaInfoGral.vue?vue&type=script&lang=ts&"
import style0 from "./TablaInfoGral.vue?vue&type=style&index=0&id=4051da34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4051da34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4051da34', component.options)
    } else {
      api.reload('4051da34', component.options)
    }
    module.hot.accept("./TablaInfoGral.vue?vue&type=template&id=4051da34&scoped=true&", function () {
      api.rerender('4051da34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Clientes/TablaInfoGral.vue"
export default component.exports